import styled from 'styled-components'

const Style = {
	SlideshowContainer: styled.div`
		position: relative;
		width: 100%;
		min-height: 90%;
		height: 90%;
		overflow: hidden;
		

	`,
	"PrizeList": styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	overflow-y: auto;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
			display: none;
	}

	& > div {
			display: flex;
			justify-content: space-between;
			align-items: center;

			& > p {
					font-family: bold;
					font-size: 24px;
			}
	}
`,
	SlideContainer: styled.div`
		opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
		transition: opacity 0.3s ease-in-out;
		transform: ${({ $isVisible }) => 
			$isVisible ? 'translateY(0)' : 'translateY(10px)'};
		transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
		height: 90%;
		overflow: hidden;
	
	`,

	NavButton: styled.button`
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		${({ $position }) => $position}: 10px;
		width: 40px;
		height: 40px;
		border-radius: 50%;
		border: 2px solid ${({ theme }) => theme.color.grey3};
		background-color: ${({ theme }) => theme.color.white};
		color: ${({ theme }) => theme.color.grey4};
		${({ theme }) => theme.font.large_bold};
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0.7;
		transition: all 0.2s ease;
		z-index: 10;

		&:hover {
			opacity: 1;
			background-color: ${({ theme }) => theme.color.grey1};
			border-color: ${({ theme }) => theme.color.grey4};
			transform: translateY(-50%) scale(1.1);
		}

		&:active {
			transform: translateY(-50%) scale(0.95);
		}

		@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
			width: 32px;
			height: 32px;
			${({ theme }) => theme.font.medium_bold};
		}
	`,

	IndicatorContainer: styled.div`
		display: flex;
		justify-content: center;
		gap: 8px;
		margin-top: 16px;

		@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
			gap: 6px;
			margin-top: 12px;
		}
	`,

	Indicator: styled.button`
		width: 12px;
		height: 12px;
		border-radius: 50%;
		border: 2px solid ${({ theme, $active, $fontColor }) => 
			$active ? $fontColor : theme.color.grey3};
		background-color: ${({ theme, $active, $fontColor }) => 
			$active ? $fontColor : theme.color.white};
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			border-color: ${({ theme }) => theme.color.major};
			transform: scale(1.2);
		}

		@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
			width: 10px;
			height: 10px;
		}
	`,

	Counter: styled.div`
		position: absolute;
		top: 10px;
		right: 10px;
		background-color: ${({ theme }) => theme.color.black};
		color: ${({ theme }) => theme.color.white};
		${({ theme }) => theme.font.extra_small};
		padding: 4px 8px;
		border-radius: 12px;
		opacity: 0.8;

		@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
			top: 8px;
			right: 8px;
			${({ theme }) => theme.font.tiny};
			padding: 2px 6px;
		}
	`,
}

export default Style
